export default {
  id: null,
  companyID: null,
  areaID: null,
  stageID: null,
  name: null,
  mnemonic: null,
  description: null,
  status: null,
  dateUpdate: null,
  accountIDUpdate: null
}



// WEBPACK FOOTER //
// ./src/shared/models/configuration/regulationtypemodel.js